import React from "react";
import "../../src/index.css"; // Import custom styles

const Services = () => {
  return (
    <section className="bg-white animate-[float_3s_ease-in-out_infinite]">
      <div className="py-8 px-4 mx-auto max-w-screen-xl sm:py-16 lg:px-6">
        <div className="max-w-screen-md mb-8 lg:mb-16">
          <h2 className="mb-4 text-4xl tracking-tight font-extrabold text-gray-900">
            The 3 easy and simple steps
          </h2>
        </div>
        <div className="space-y-8 md:grid md:grid-cols-2 lg:grid-cols-3 md:gap-12 md:space-y-0">
          {/* Step 1 */}
          <div>
            <div className="flex justify-center items-center mb-4 w-10 h-10 rounded-full bg-primary-100 lg:h-12 lg:w-12 pulse-icon">
              <svg
                className="w-6 h-6 text-primary-600"
                fill="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M12 3a3 3 0 00-3 3c0 .68.21 1.31.56 1.83A3 3 0 009 9H3v10a2 2 0 002 2h14a2 2 0 002-2V9h-6a3 3 0 00-2.44-1.17A3 3 0 0012 3zm0 2a1 1 0 011 1v1h-2V6a1 1 0 011-1zM5 11h14v8H5v-8z"></path>
              </svg>
            </div>
            <h3 className="mb-2 text-xl font-bold bg-gradient-to-r from-[#C8266F] to-[#1BA9F4] bg-clip-text text-transparent underline-hover">
              You Buy the Gift
            </h3>
            <p className="text-gray-500">
              With a one-time £5 payment, you set up a year-long surprise for someone special. No subscriptions, no hidden fees—just a thoughtful, long-lasting gift.
            </p>
          </div>

          {/* Step 2 */}
          <div>
            <div className="flex justify-center items-center mb-4 w-10 h-10 rounded-full bg-primary-100 lg:h-12 lg:w-12 pulse-icon">
              <svg
                className="w-6 h-6 text-primary-600"
                fill="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M14 3l1.41 1.41-1.83 1.83L12 4.83 14 3zm6 8h-3v-2h3v2zm-6 8l1.41 1.41-1.83 1.83L12 19.83 14 17zm-6-8H5v-2h3v2zm9.29-5.71L17 4.41l-1.88 1.88L15.41 7l1.88-1.88zM3 12h3v2H3v-2zm9-9h2v3h-2V3zm0 18h2v3h-2v-3zm8.71-3.29l-1.41-1.41-1.88 1.88L19 19.71l1.41-1.41z"></path>
              </svg>
            </div>
            <h3 className="mb-2 text-xl font-bold bg-gradient-to-r from-[#C8266F] to-[#1BA9F4] bg-clip-text text-transparent underline-hover">
              We Customise It
            </h3>
            <p className="text-gray-500">
              Our AI crafts personalised motivational messages tailored to their name, personality, and interests, ensuring each one feels meaningful and unique.
            </p>
          </div>

          {/* Step 3 */}
          <div>
            <div className="flex justify-center items-center mb-4 w-10 h-10 rounded-full bg-primary-100 lg:h-12 lg:w-12 pulse-icon">
              <svg
                className="w-6 h-6 text-primary-600"
                fill="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M20 3h-4a2 2 0 00-2 2v4a2 2 0 002 2h4a2 2 0 002-2V5a2 2 0 00-2-2zm-1 2v4h-2V5h2zM4 5a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2v-2h-2v2H4V7h8V5H4zm9.5 7.5l-2.5 2.5-2.5-2.5-1.5 1.5 4 4 4-4-1.5-1.5z"></path>
              </svg>
            </div>
            <h3 className="mb-2 text-xl font-bold bg-gradient-to-r from-[#C8266F] to-[#1BA9F4] bg-clip-text text-transparent underline-hover">
              They Receive Monthly Surprises
            </h3>
            <p className="text-gray-500">
              Every month, they’ll get a new uplifting message delivered straight to their email or WhatsApp, keeping them inspired all year round.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
